import { createRouter, createWebHashHistory } from 'vue-router';
import { ElNotification } from 'element-plus';
import config from "@/config";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import tool from '@/utils/tool';
import { filterMenuResources } from '@/utils/menuResources';
import { getFirstAccessiblePath } from '@/layout/sidebarVisibility';
import systemRouter from './systemRouter';
import userRoutes from '@/config/route'
import store from '@/store'
import {beforeEach, afterEach} from './scrollBehavior'

//系统路由
const routes = systemRouter

//系统特殊路由
// const routes_404 = {
// 	path: "/:pathMatch(.*)*",
// 	hidden: true,
// 	component: () => import(/* webpackChunkName: "404" */ '@/layout/other/404'),
// }
// let routes_404_r = ()=>{}

const router = createRouter({
	history: createWebHashHistory(),
	routes: routes
})

//设置标题
document.title = config.APP_NAME

//判断是否已加载过动态/静态路由
var isGetRouter = false;

router.beforeEach(async (to, from, next) => {

	NProgress.start()
	//动态标题
	// document.title = to.meta.title ? `${to.meta.title} - ${config.APP_NAME}` : `${config.APP_NAME}`

	let token = tool.cookie.get("Admin-Token");

	if(to.path === "/login"){
		//删除路由(替换当前layout路由)
		router.addRoute(routes[0])
		//删除路由(404)
		// routes_404_r()
		store.commit('setUserInfo', {}) // 清除登录信息
		store.commit('setCommonObj', {key: 'dictList', value: []})
		store.commit('setCommonObj', {key: 'menuList', value: []})
		store.commit('setCommonObj', {key: 'btnsPermission', value: []})
		tool.cookie.remove('Admin-Token')
		;['Login-UserId', 'Login-Password', 'USER_INFO'].forEach(key => tool.data.remove(key))
		isGetRouter = false;
		next();
		return false;
	}

	if(routes.findIndex(r => r.path === to.path) >= 0 && to.path !== '/403' && to.path !== '/'){
		next();
		return false;
	}

	if(!token){
		next({
			path: '/login'
		});
		return false;
	}

	// 403 是独立的恢复页面，不依赖菜单、字典等接口，避免拒绝请求后循环初始化。
	if (to.path === '/403') {
		next()
		return
	}

	//整页路由处理
	if(to.meta.fullpage){
		to.matched = [to.matched[to.matched.length-1]]
	}
	//加载动态/静态路由
	if(!isGetRouter){
		try {
			let apiMenu = store.getters['menuList'] || []
			if (apiMenu.length === 0) {
				await store.dispatch('getMenuList')
				apiMenu = store.getters['menuList'] || []
			}
			let userInfo = tool.data.get("USER_INFO") || {}
			let userMenu = treeFilter(userRoutes, node => {
				return node.meta.role ? node.meta.role.some(item => (userInfo.role || []).includes(item)) : true
			})
			let menu = [...userMenu, ...apiMenu]
			var menuRouter = filterAsyncRouter(menu)
			menuRouter = flatAsyncRoutes(menuRouter)
			menuRouter.forEach(item => {
				router.addRoute("layout", item)
			})
			isGetRouter = true;
			if (to.matched.length === 0 && router.resolve(to.fullPath).matched.length > 0) {
				next({ ...to, replace: true })
				return
			}
		} catch (error) {
			isGetRouter = false
			next({ path: '/login', replace: true })
			return
		}
	}
	const firstPath = getFirstAccessiblePath(store.getters['menuList'])
	if (!firstPath) {
		ElNotification.error({ title: '无法进入系统', message: '未配置权限，请联系超管' })
		next({ path: '/login', replace: true })
		return
	}
	// 首页入口或旧的无权限地址统一落到首个授权页面，不渲染空的 router-view。
	if (to.path === '/' || to.path === '/home' || router.resolve(to.fullPath).matched.length === 0) {
		next({ path: firstPath, replace: true })
		return
	}
	// 用户信息属于会话校验；失败时先停止导航，不再连带触发其他初始化请求。
	if (Object.keys(store.getters['userInfo'] || {}).length === 0) {
		try {
			await store.dispatch('getUserInfo')
		} catch (error) {
			next({ path: '/login', replace: true })
			return
		}
	}
	if ((store.getters['dictList'] || []).length === 0) {
		store.dispatch('getDictList').catch(() => {
			// 请求拦截器已提示失败，字典失败不能变成未捕获异常。
		})
	}
	beforeEach(to, from)
	next();
});

router.afterEach((to, from) => {
	afterEach(to, from)
	NProgress.done()
});

router.onError((error) => {
	NProgress.done();
	ElNotification.error({
		title: '路由错误',
		message: error.message
	});
});

//入侵追加自定义方法、对象
router.puc_getMenu = () => {
	var apiMenu = store.getters['menuList'] || []
	let userInfo = tool.data.get("USER_INFO") || {}
	let userMenu = treeFilter(userRoutes, node => {
		return node.meta.role ? node.meta.role.some(item => (userInfo.role || []).includes(item)) : (node.meta.type ? node.meta.type !== 'router' : true)
	})
	var menu = [...userMenu, ...apiMenu]
	return filterMenuResources(menu)
}

//转换
function filterAsyncRouter(routerMap) {
	const accessedRouters = []
	filterMenuResources(routerMap).forEach(item => {
		item.meta = item.meta?item.meta:{};
		//处理外部链接特殊路由
		if(item.meta.type=='iframe'){
			item.meta.url = item.path;
			item.path = `/i/${item.name}`;
		}
		//MAP转路由对象
		var route = {
			path: item.path,
			name: item.name,
			meta: item.meta,
			redirect: item.children && item.children.findIndex(option => option.path === item.redirect) > -1 ? item.redirect : (item.children && item.children.length > 0 ? item.children[0].path : null),
			children: item.children ? filterAsyncRouter(item.children) : null,
			component: loadComponent(item.component)
		}
		accessedRouters.push(route)
	})
	return accessedRouters
}
function loadComponent(component){
	if(component){
		return () => import(/* webpackChunkName: "[request]" */ `@/pages/${component}`)
	}else{
		return () => import(`@/layout/other/empty`)
	}

}

//路由扁平化
function flatAsyncRoutes(routes, breadcrumb=[]) {
	let res = []
	routes.forEach(route => {
		const tmp = {...route}
        if (tmp.children) {
            let childrenBreadcrumb = [...breadcrumb]
            childrenBreadcrumb.push(route)
            let tmpRoute = { ...route }
            tmpRoute.meta.breadcrumb = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
            childrenRoutes.map(item => {
                res.push(item)
            })
        } else {
            let tmpBreadcrumb = [...breadcrumb]
            tmpBreadcrumb.push(tmp)
            tmp.meta.breadcrumb = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

//过滤树
function treeFilter(tree, func) {
	return tree.map(node => ({ ...node })).filter(node => {
		node.children = node.children && treeFilter(node.children, func)
		return func(node) || (node.children && node.children.length)
	})
}

export default router
